<template>
    <div v-if="display" class="row">
        <div class="col">
            <sub-section :title="title" :showHelp="false">
                <div class="container-fluid">
                    <div v-for="(advisor, i) in advisors" :key="`advisor${i}`" class="row pt-3 row-divider">
                        <div v-if="showLogoAndButton" class="d-block col-md-2 ps-0">
                            <img :src="advisor.image" class="w-100" :alt="advisor.name" />
                        </div>
                        <div class="d-block pt-4 pt-md-0 px-0 ps-md-4" :class="descClasses">
                            <p v-for="(desc, j) in advisor.description" :key="`desc${j}`" v-html="desc"></p>
                        </div>
                        <div v-if="showLogoAndButton" class="d-block col-md-2 pe-0">
                            <button v-if="hasMoreDetails(advisor.key)" class="btn btn-primary btn-sm float-end ms-2 mt-2" @click="onMoreDetailsClick(advisor.key)">More details</button>
                            <button class="btn btn-primary btn-sm float-end ms-2 mt-2" @click="onFindAdviceClick(advisor.key)">Find advice</button>
                        </div>
                    </div>
                </div>
            </sub-section>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, watch, nextTick } from "vue";
import Monitoring from "@/guiide/ts/monitoring";
import SubSection from "../common/SubSection.vue";
import { useStore } from "vuex";
import { AdviserResponse } from "@/guiide/ts/response/adviserResponse";
import { app } from "@/guiide/ts/app";
import AdviserListDisplayMode from "@/guiide/ts/adviserListDisplayMode";

const props = defineProps({
    alwaysDisplay: {
        type: Boolean,
        default: false,
        required: false
    }
});

const store = useStore();
const display = computed<boolean>(() => props.alwaysDisplay || store.state.configuration.finishDisplaysAdvisors);
const advisors = computed<Array<AdviserResponse>>(() => store.state.advisers);
const title = computed<string>(() => store.state.configuration?.adviserListTitle ?? "");
const showLogoAndButton = computed<boolean>(() => {
    return (store.state.configuration?.adviserListDisplayMode ?? AdviserListDisplayMode.Full) == AdviserListDisplayMode.Full;
});
const descClasses = computed<string>(() => showLogoAndButton.value ? "col-md-8" : "col-md-12");

onMounted(() => {
    if (advisors.value == null || advisors.value.length == 0) {
        app.getAdvisers();
    }
})

watch(
    advisors,
    () => {
        nextTick(() => {
            document.querySelectorAll('[data-redirect]').forEach(button => {
                button.removeEventListener('click', handleRedirect);
                button.addEventListener('click', handleRedirect);
            });
        });
    },
    { immediate: true });

const handleRedirect = (event) => {
  const url = event.currentTarget.dataset.redirect;
  if (url) {
    window.location = url;
  }
};

function hasMoreDetails(advisorKey: string) {
    const advisor = advisors.value.find(a => a.key == advisorKey);
    return advisor.moreDetailsUrl.length > 0;
}

function onFindAdviceClick(advisorKey: string) {
    const advisor = advisors.value.find(a => a.key == advisorKey);
    const potsValue = store.state.retiree?.pensionPots.presentValue ?? 0;
    Monitoring.gaEvent(advisor.key, potsValue);
    window.open(advisor.findAdviceUrl, "_blank");
}

function onMoreDetailsClick(advisorKey: string) {
    const advisor = advisors.value.find(a => a.key == advisorKey);
    window.open(advisor.moreDetailsUrl, "_blank");
}
</script>

<style scoped>
.row-divider:not(:last-of-type) {
    border-bottom: 1px solid lightgray;
    margin-bottom: 0.3rem;
    padding-bottom: 0.3rem;
}
</style>
